import {Perf10t} from './Perf10t';

export const mark: Perf10t['mark'] = (markName, markOptions) => {
    if (!window.perf10t) {
        return;
    }

    return window.perf10t.mark(markName, markOptions);
};
